import react from "react";

export const HelloworldPage = () => {
  return (
    <div>
      <h3>Hello World</h3>
    </div>
  );
};
